import { create } from 'zustand';

import { MapStyle } from '@/types/MapStyle';

interface MapState {
  style: MapStyle;

  actions: {
    setStyle: (style: MapStyle) => void;
  };
}

export const useMapStore = create<MapState>()((set) => ({
  style: MapStyle.BASIC,

  actions: {
    setStyle: (style) => set({ style }),
  },
}));
